import {
  flexbox,
  fullWidth,
  paddingX,
  paddingY,
  posRelative,
  theme,
} from "emotion/utils";

import bgGirlHorse from "images/kids-riding-horses.jpg";

export const css = {
  container: (image) => ({
    ...posRelative(),
    backgroundColor: theme.colors.white,
    backgroundImage: `url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",

    frame: {
      ...flexbox("column", "flex-start", "flex-start"),

      "@media screen and (min-width: 992px)": {
        ...flexbox("row", "center", "space-between", 34),
      },

      "> div:first-of-type": {
        ...fullWidth(),
        ...paddingX(16),
        ...paddingY(48),

        "@media screen and (min-width: 576px)": {
          ...paddingX(38),
          ...paddingY(64),
        },
        "@media screen and (min-width: 992px)": {
          maxWidth: 660,
          paddingLeft: 100,
        },
        "@media screen and (min-width: 1200px)": {
          paddingLeft: 150,
        },
      },
    },
  }),

  image: {
    ...fullWidth(),
    backgroundImage: `url(${bgGirlHorse})`,
    backgroundSize: "cover",
    height: 250,

    "@media screen and (min-width: 420px)": {
      height: 400,
    },
    "@media screen and (min-width: 992px)": {
      width: "40%",
      height: 680,
    },
    "@media screen and (min-width: 1200px)": {
      width: "45%",
      height: 735,
    },
    "@media screen and (min-width: 1400px)": {
      height: 650,
      width: "50%",
    },
  },
};
